import { useEffect, useState } from 'react';
import styled from 'styled-components';
import PurpleImage1 from '../../assets/images/purple_1.png';
import PurpleImage2 from '../../assets/images/purple_2.png';
import FadeInUp from '../animation/FadeInUp';

const images = [PurpleImage1, PurpleImage2];

const PurpleSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <StyledSection>
      <FadeInUp
        positionValue={-60}
        addedStyle={{ position: 'relative', 'z-index': '2' }}
      >
        <StyledH2>Our Wedding</StyledH2>
      </FadeInUp>
      <ImageWrapper>
        {images.map((image, index) => (
          <StyledImage
            key={index}
            src={image}
            isVisible={index === currentImageIndex}
          />
        ))}
      </ImageWrapper>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  position: relative;
  background-color: var(--purple);
  padding: 6.5rem 4rem 5rem;
  overflow: hidden;
`;

const StyledH2 = styled.h2`
  position: absolute;
  top: 3rem;
  left: 50%;
  transform: translateX(-50%);
  width: 26rem;
  font-family: var(--dearly-loved);
  font-size: 4rem;
  text-align: center;
  font-weight: 500;
  z-index: 2;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 54rem;
  overflow: hidden;
`;

const StyledImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 2s ease-in-out;
  z-index: 1;
`;

export default PurpleSection;
